import * as vp from 'vopay';
import { FunctionComponent } from 'react';

const { Button, Box, Title } = vp;

type TwoFactorAuthenticationQRCodeProps = {
  handleContinue: () => void;
  QRCode: string;
};

type FC = FunctionComponent<TwoFactorAuthenticationQRCodeProps>;
const TwoFactorAuthenticationQRCode: FC = (props: TwoFactorAuthenticationQRCodeProps) => {
  const { handleContinue, QRCode } = props;
  return (
    <Box flx="col">
      <Box mb="sm" flx="col" ai="center" height="auto">
        <Title title="Scan the QR Code with the App" bold size="xsm" />
      </Box>
      <Box ai="center" jc="center" pb="md">
        <img src={QRCode} alt="QR Code" />
      </Box>
      <Box jc="fe" flx="col" height="auto">
        <Button
          id="enable-2-fa"
          type="button"
          label="Next"
          size="xlg"
          textSize={1}
          onClick={() => {
            handleContinue();
          }}
        />
      </Box>
    </Box>
  );
};
export default TwoFactorAuthenticationQRCode;
